import React, { useState, useEffect } from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import parse, { domToReact } from 'html-react-parser';
import { BASE_URL } from '../network/endpoints';
import instId from '../network/instituteId';

const BlogSection = () => {

    function linkifyHtml(htmlString) {
        const urlRegex = /((https?:\/\/[^\s<]+))/g;
        return htmlString.replace(urlRegex, (url) => {
            if (htmlString.includes(`<a href="${url}`)) return url;
            return `<a href="${url}">${url}</a>`;
        });
    }
    const options = {
        replace: (domNode) => {
            if (domNode.name === 'a' && domNode.attribs?.href) {
                const href = domNode.attribs.href;
                const anchorText = domNode.children?.[0]?.data?.toLowerCase?.() || '';
                const isDownloadLink =
                    anchorText.includes('click here to download') ||
                    anchorText.includes('click to download');

                const handleDownload = async (e) => {
                    e.preventDefault();

                    try {
                        const response = await fetch(href);
                        const blob = await response.blob();

                        const fileName = href.split('/').pop().split('?')[0] || 'downloaded_file';
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = fileName;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);
                    } catch (error) {
                        console.error('Download failed:', error);
                        window.open(href, '_blank'); // fallback
                    }
                };

                return isDownloadLink ? (
                    <a
                        href={href}
                        onClick={handleDownload}
                        style={{ color: '#1976d2', textDecoration: 'underline', cursor: 'pointer' }}
                    >
                        {domToReact(domNode.children, options)}
                    </a>
                ) : (
                    <a
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#1976d2', textDecoration: 'underline' }}
                    >
                        {domToReact(domNode.children, options)}
                    </a>
                );
            }

            if (domNode.name === 'img' && domNode.attribs?.src) {
                return (
                    <img
                        src={domNode.attribs.src}
                        alt={domNode.attribs.alt || ''}
                        style={{ width: '100%', maxWidth: '100%', height: 'auto' }}
                    />
                );
            }
        },
    };

    const isMobile = useMediaQuery("(min-width:600px)");
    const location = useLocation();
    const navigate = useNavigate();
    const blogsData = location?.state?.blogData;
    const rawHtml = blogsData?.blog?.blog || '';
    const htmlWithLinks = linkifyHtml(rawHtml);
    const parsedContent = parse(rawHtml, options);
    const [Endpoints, setEndpoints] = useState('');

    useEffect(() => {
        if (!blogsData?.id) {
            navigate('/free-resouces')
        }
    }, [blogsData])

    useEffect(() => {
        window.scrollTo(0, 0);
        getInstituteDetail();
    }, []);


    const getInstituteDetail = async () => {
        try {
            let requestOptions = {
                // headers: { "X-Auth": token },
                withCredentials: false,
            };
            const response = await axios.get(
                BASE_URL + "/getMetaData/fetch-institute/" + instId,
                requestOptions
            );
            if (response?.data?.errorCode === 0) {
                setEndpoints(response?.data?.instituteTechSetting?.mediaUrl)
                // Endpoints = response?.data?.instituteTechSetting?.mediaUrl
            };
        } catch (error) {
            console.log(error);
        }
    };

    // console.log('blogsData', blogsData);

    return (
        <React.Fragment>
            <Box style={{ padding: !isMobile ? '8rem 10px 0' : '8rem 40px 0px' }}>
                <div style={{ paddingLeft: isMobile ? '0rem' : '0rem', paddingRight: isMobile ? '0rem' : '0rem', paddingTop: isMobile ? '2rem' : '1rem', paddingBottom: isMobile ? '2rem' : '1rem' }}>
                    <Box sx={{ width: '100%', textAlign: "left" }}>
                        <Box sx={{ textAlign: "center" }}>
                            {
                                blogsData?.thumb && (
                                    <img src={Endpoints + blogsData?.thumb} style={{ borderRadius: "8px", width: !isMobile ? "-webkit-fill-available" : "" }} />
                                )
                            }
                        </Box>
                        <Typography variant='h5' fontWeight={"bold"} sx={{ mt: 2, mb: 2, ml: 2, mr: 2, color: "black", pt: 2, textAlign: "center" }}>
                            {blogsData?.title}

                        </Typography>
                        <Box sx={{ mt: 2, mb: 2, ml: 2, mr: 2 }}>{parsedContent}</Box>
                    </Box>
                </div>
            </Box>
        </React.Fragment>

    );
};

export default BlogSection;
